import { NEW_API_URL } from "./api-client";
import { APIParser, APIDownloadFile } from "./api-parser";
import {
  createFetchGetOptions,
  createFetchPostOptions,
  createURLWithQueryParams,
  getToken,
} from "./api-util";
import triyoAPI from "./triyo";
import { config } from "../../util/axios-config";

const baseDynamicFieldsURL = `${NEW_API_URL}dynamic-fields/`;
const baseDynamicFieldsDesignerURL = `${NEW_API_URL}dynamic-fields-designer/`;
const baseDynamicFieldsRegexURL = `${NEW_API_URL}dynamic-fields-regex/`;
const baseDynamicFieldsMasksURL = `${NEW_API_URL}dynamic-fields-masks/`;
const baseDynamicFieldsObjectsURL = `${NEW_API_URL}dynamic-fields-objects/`;
const bulkDynamicFieldsObjectsURL = `${NEW_API_URL}dynamic-fields-bulk-edit/`;
const bulkDynamicFieldsObjectsREURL = `${NEW_API_URL}dynamic-fields-bulk-edit-re/`;
const dynamicFormAutomationBaseURL = `${NEW_API_URL}dynamic-form-automations/`;

// interface DynamicFieldsRequestDto {
//      taskTypeId: Integer;
//      projectTypeId: Integer;
//      objectType: string; see OBJECT_TYPES for valid values
//      objectId?: Integer; id of comment associated with dynamic field
//  }

// interface DynamicFieldsDataDto {
//      ObjectId: Integer
//      DynamicFieldId: Integer
//      Data: string
//  }

// valid values for objectType parameter
export const OBJECT_TYPES = {
  taskComment: "TaskComment",
  taskDetail: "TaskDetail",
  project: "Project",
};

// provide objectId when retrieving comments to populate fields associated with those comments
// otherwise, when not providing objectId, you only get the field types without the data
// dynamicFieldsRequestDto: DynamicFieldsRequestDto
export async function getDynamicFields(dynamicFieldsRequestDto) {
  // TODO: for now projectTypeId is always passed as 1, but should be updated when necessary
  const url = createURLWithQueryParams(baseDynamicFieldsURL, {
    ...dynamicFieldsRequestDto,
  });

  const response = await fetch(url, createFetchGetOptions());

  return APIParser(response);
}

// dynamicFieldDataDto: DynamicFieldDataDto[]
export async function saveDynamicFields(dynamicFieldsDataDto) {
  const url = new URL(baseDynamicFieldsURL);
  const options = createFetchPostOptions(dynamicFieldsDataDto);
  const response = await fetch(url, options);

  // returned json is empty, so calling APIParser normally,
  // which calls response.json(), would throw an error
  return response.ok ? response : Promise.reject(response);
}

// only taskTypeId is required
export async function getDynamicFieldsDesigner(dynamicFieldsRequestDto) {
  return getDynamicFieldsForDesign(
    baseDynamicFieldsDesignerURL,
    dynamicFieldsRequestDto
  );
}

// only taskTypeId is required
export async function getDynamicFieldsRegex(dynamicFieldsRequestDto) {
  return getDynamicFieldsForDesign(baseDynamicFieldsRegexURL);
}

// only taskTypeId is required
export async function getDynamicFieldsMasks(dynamicFieldsRequestDto) {
  return getDynamicFieldsForDesign(baseDynamicFieldsMasksURL);
}

// only taskTypeId is required
export async function getDynamicFieldsObjects() {
  return getDynamicFieldsForDesign(baseDynamicFieldsObjectsURL);
}

// "Label": string,
// "FieldMaskId": int,
// "FieldRegexId": int,
// "Visible": true,
// "Deleted": false,
// "Lookup": false,
// "FieldHelp": "",
// "FieldType": "SingleText",
// "Required": boolean,
// "ObjectType": "TaskComment",
// "TaskTypeId": integer,
// "Order": integer
export async function saveDynamicFieldsDesigner(
  taskTypeId,
  projectTypeId,
  dynamicFieldsDto
) {
  const url = createURLWithQueryParams(baseDynamicFieldsDesignerURL, {
    taskTypeId,
    projectTypeId,
  });
  const options = createFetchPostOptions(dynamicFieldsDto);
  const response = await fetch(url, options);

  return response.ok ? response : Promise.reject(response);
}

async function getDynamicFieldsForDesign(baseURL, dynamicFieldsRequestDto) {
  const url = createURLWithQueryParams(baseURL, dynamicFieldsRequestDto);
  const response = await fetch(url, createFetchGetOptions());
  return APIParser(response);
}

export const ExportDynamicTable = (excelDto) => {
  let data = JSON.stringify(excelDto);
  let token = getToken();
  return fetch(NEW_API_URL + "exportDynamicTable", {
    method: "POST",
    body: data,
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  }).then((response) => APIDownloadFile(response));
};

export const getBulkDynamicFields = async (dynamicFieldsRequestDto) => {
  const url = createURLWithQueryParams(
    bulkDynamicFieldsObjectsURL,
    dynamicFieldsRequestDto
  );
  const response = await fetch(url, createFetchGetOptions());
  return APIParser(response);
};

export const getBulkDynamicFieldsRE = async (data) => {
  return triyoAPI.post(bulkDynamicFieldsObjectsREURL, data, config());
};

export const saveBulkDynamicFields = async (dynamicFieldsRequestDto) => {
  const url = createURLWithQueryParams(bulkDynamicFieldsObjectsURL);
  const response = await fetch(
    url,
    createFetchPostOptions(dynamicFieldsRequestDto)
  );
  return response;
};

export const GetDynamicFieldRepository = () => {
  return triyoAPI.get("/DynamicFields/GetDynamicFieldRepository", config());
};

export const GetDynamicFieldRepositoryForTaskType = () => {
  return triyoAPI.get("/DynamicFields/GetDynamicFieldRepositoryForTaskType", config());
};

export const AddDynamicFieldRepository = (data) => {
  return triyoAPI.post(
    "/DynamicFields/AddDynamicFieldRepository",
    data,
    config()
  );
};

export const EditDynamicFieldRepository = (data) => {
  return triyoAPI.post(
    "/DynamicFields/EditDynamicFieldRepository",
    data,
    config()
  );
};

export async function getDynamicFormAutomations(taskTypeId, formId) {
  const url = `${dynamicFormAutomationBaseURL}all/${taskTypeId}/${encodeURIComponent(formId)}`;
  const response = await fetch(url, createFetchGetOptions());
  return APIParser(response);
}